module.exports = __webpack_public_path__ + "img/chrome4.f3dc75a3.png";